// extracted by mini-css-extract-plugin
export default {"OrderCloseForm":"OrderCloseForm_OrderCloseForm__ei4J4"};